import { ArrowForward, ArrowBack } from "@mui/icons-material";
import styled from "styled-components";
import Island from "./Components/Island";
import { useMapData } from "../../mapData/MapDataProvider";
import { useParams } from "react-router-dom";
import { useState } from "react";
import LearnMore from "./Components/LearnMore";
import { useIntl } from "react-intl";

const Landmark = () => {
  const data = useMapData();
  const { id } = useParams();
  const landmark = data.find((item) => item.id === id);
  const [imageId, setImageId] = useState(0);
  const intl = useIntl();

  const quoteParser = (quote) => {
    if (quote.length <= 0) return;
    const englishQuotes = quote.filter(
      (quote) => quote.type === "en" && quote.type !== "attribution"
    );
    const chineseQuotes = quote.filter(
      (quote) => quote.type === "zh" && quote.type !== "attribution"
    );

    return (
      <>
        { intl.locale === "en" ? <EnglishQuote>
          <QuoteMarks>“</QuoteMarks>
          {englishQuotes.map((item, index) => (
            <div key={index}>
              {item.default}
              <br />
              <br />
            </div>
          ))}

          <Attributions>
            <b>Source: </b>
            {
              landmark.quote.find((item) => item.type === "attribution")
                .default
            }
          </Attributions>
        </EnglishQuote> : null }
        { intl.locale === "zh" ? <ChineseQuote>
            {chineseQuotes.map((item) => (
              <div>
                {item.default}
                <br />
                <br />
              </div>
            ))}
            <QuoteMarks>”</QuoteMarks>

            <Attributions>
              <b>Source: </b>
              {
                landmark.quote.find((item) => item.type === "attribution")
                  .default
              }
            </Attributions>
          </ChineseQuote>
          : null }
      </>
    );
  };

  const handleNegativeClick = () => {
    if (imageId - 1 < 0) return;

    setImageId(imageId - 1);
  };

  const handlePositiveClick = () => {
    const limit = landmark.images.length;

    if (imageId + 1 === limit) return;

    setImageId(imageId + 1);
  };

  return (
    <Wrapper>
      <BodyWrapper>
        <Island data={landmark} />
        <Body>
          <MobileCarousel>
            <Carousel>
              <CarouselButton
                limit={landmark.images.length - 1 === imageId}
                pos={"right"}
                onClick={handlePositiveClick}
              >
                <ArrowForward />
              </CarouselButton>
              <CarouselButton
                limit={imageId === 0}
                pos={"left"}
                onClick={handleNegativeClick}
              >
                <ArrowBack />
              </CarouselButton>
              {landmark.images && (
                <a href={landmark.images[imageId].link}>
                  <img
                    src={landmark.images[imageId].link}
                    style={{
                      height: "500px",
                      margin: "auto",
                      width: "100%",
                      objectFit: "cover",
                      "@media (maxWidth: 800px)": {
                        height: "auto",
                        maxHeight: "500px",
                      },
                    }}
                    alt=""
                  />
                </a>
              )}
            </Carousel>
            <ImageCaption>{landmark.images[imageId].caption}</ImageCaption>
            <ImageCaptionChinese>
              {landmark.images[imageId].chCaption}
            </ImageCaptionChinese>
            <Counter>
              {imageId + 1}/{landmark.images.length}
            </Counter>
          </MobileCarousel>
          {landmark.description.filter(({ type }) => type === intl.locale).map((item, index) => {
            if (intl.locale === "en") {
              return <EnglishText key={index}>{item.default}</EnglishText>;
            } else {
              return <ChineseText key={index}>{item.default}</ChineseText>;
            }
          })}
          {quoteParser(landmark.quote)}
          <DesktopCarousel>
            <Carousel>
              <CarouselButton
                limit={landmark.images.length - 1 === imageId}
                pos={"right"}
                onClick={handlePositiveClick}
              >
                <ArrowForward />
              </CarouselButton>
              <CarouselButton
                limit={imageId === 0}
                pos={"left"}
                onClick={handleNegativeClick}
              >
                <ArrowBack />
              </CarouselButton>
              {landmark.images && (
                <a href={landmark.images[imageId].link}>
                  <img
                    src={landmark.images[imageId].link}
                    style={{
                      height: "500px",
                      margin: "auto",
                      width: "100%",
                      objectFit: "cover",
                      "@media (maxWidth: 800px)": {
                        height: "auto",
                        maxHeight: "500px",
                      },
                    }}
                    alt=""
                  />
                </a>
              )}
            </Carousel>
            { intl.locale === "en" ? <ImageCaption>{landmark.images[imageId].caption}</ImageCaption> : <ImageCaptionChinese>{landmark.images[imageId].chCaption}</ImageCaptionChinese> }
            <Counter>
              {imageId + 1}/{landmark.images.length}
            </Counter>
          </DesktopCarousel>
          {landmark?.secondaryQuote && quoteParser(landmark.secondaryQuote)}
          <Border />
          {landmark?.resources && (
            <div>
              <LearnMoreTitle>Learn More</LearnMoreTitle>
              <LearnMoreSubtitle>
                Check out more resources submitted by our community.
              </LearnMoreSubtitle>
              {landmark.resources?.map((resource) => {
                return <LearnMore key={resource.title} resource={resource} />;
              })}
            </div>
          )}
        </Body>
      </BodyWrapper>
    </Wrapper>
  );
};

export default Landmark;

const LearnMoreSubtitle = styled.div`
    font-family: "Quattrocento";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 16px;
    color: #423f67;
`;

const LearnMoreTitle = styled.div`
    margin-bottom: 16px;
    font-family: "Rowdies";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;

    color: #423f67;
    text-transform: uppercase;
`;

const Border = styled.div`
    border-top: 1px solid rgba(66, 63, 103, 0.25);
    margin: 32px 0px;
    width: 100%;
`;

const ImageCaption = styled.div`
    font-family: "Quattrocento";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #1e1e1e;
    @media (max-width: 800px) {
        margin-top: 16px;
    }
`;

const ImageCaptionChinese = styled(ImageCaption)`
    font-family: "Noto Serif TC";
`;

const Counter = styled.div`
    font-family: "Quattrocento";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    margin-top: 16px;

    color: #1e1e1e;
`;

const CarouselButton = styled.button`
    position: absolute;
    top: calc(50% - 8px);
    left: ${(props) => props.pos === "left" && "8px"};
    right: ${(props) => props.pos === "right" && "8px"};
    opacity: ${(props) => props.limit && 0.5};
    display: flex;
    align-items: center;
    justify-content: center;
    background: #423f67;
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    border: none;
    cursor: ${(props) => !props.limit && "pointer"};
    @media (max-width: 800px) {
        left: ${(props) => props.pos === "left" && "32px"};
        right: ${(props) => props.pos === "right" && "32px"};
    }
`;

const Carousel = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    @media (max-width: 800px) {
        margin: 0 -32px;
        width: calc(100% + 64px);
    }
`;

const Attributions = styled.div`
    font-family: "Quattrocento";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    /* identical to box height, or 162% */

    color: #1e1e1e;
`;

const QuoteMarks = styled.div`
    font-family: "Rowdies";
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    /* or 119% */

    text-transform: uppercase;

    color: #423f67;
`;

const EnglishText = styled.div`
    font-family: "Quattrocento";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 32px;
    color: #1e1e1e;
    @media (max-width: 800px) {
        margin-top: 32px;
    }
`;

const ChineseText = styled.div`
    font-family: "Noto Serif TC";
    margin-bottom: 32px;
    @media (max-width: 800px) {
        margin-top: 32px;
    }
`;

const ChineseQuote = styled.div`
    padding: 16px 32px;
    color: #423f67;
    font-weight: 500;
    font-family: "Noto Serif TC";
`;

const EnglishQuote = styled.div`
    padding: 16px 32px;
    color: #423f67;
    font-weight: 300;
    font-family: "Rowdies";
`;

const BodyWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    @media (max-width: 800px) {
        flex-direction: column;
    }
`;

const Body = styled.div`
    padding: 32px 48px 150px 48px;
    box-sizing: border-box;
    overflow-y: scroll;
    height: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(66, 63, 103, 0.25);
    ::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 800px) {
        height: 100%;
        border-left: none;
    }
`;

const IslandWrapper = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 300px;
    background-color: #fbf6e9;
    @media (max-width: 800px) {
        position: relative;
        width: 100%;
        height: auto;
    }
`;

const Wrapper = styled.div`
    display: flex;
    background-color: #fbf6e9;
    justify-content: center;
`;

const MobileCarousel = styled.div`
    display: none;
    @media (max-width: 800px) {
        display: block;
        width: 100%;
        overflow: hidden;
    }
`;

const DesktopCarousel = styled.div`
    display: block;
    @media (max-width: 800px) {
        display: none;
    }
`;
